import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './store/authStore'
import Layout from './components/layout/Layout'
import Login from './pages/Login'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import Dashboard from './pages/Dashboard'
import Extensions from './pages/Extensions'
import Trunks from './pages/Trunks'
import IVR from './pages/IVR'
import TimeConditions from './pages/TimeConditions'
import Queues from './pages/Queues'
import RingGroups from './pages/RingGroups'
import Conferences from './pages/Conferences'
import Recordings from './pages/Recordings'
import CallRecording from './pages/CallRecording'
import InboundRoutes from './pages/InboundRoutes'
import OutboundRoutes from './pages/OutboundRoutes'
import Phonebook from './pages/Phonebook'
import ExternalDestinations from './pages/ExternalDestinations'
import CDR from './pages/CDR'
import Tenants from './pages/Tenants'
import Users from './pages/Users'
import Settings from './pages/Settings'
import GlobalSettings from './pages/GlobalSettings'
import Wizard from './pages/Wizard'
import Voicemail from './pages/Voicemail'
import Parking from './pages/Parking'
import Paging from './pages/Paging'
import Blacklist from './pages/Blacklist'
import MusicOnHold from './pages/MusicOnHold'
import FeatureCodes from './pages/FeatureCodes'
import Provisioning from './pages/Provisioning'
import SoftphoneProvisioning from './pages/SoftphoneProvisioning'
import Firmware from './pages/Firmware'
import NightMode from './pages/NightMode'
import Announcements from './pages/Announcements'
import Fail2Ban from './pages/Fail2Ban'
import AmiUsers from './pages/AmiUsers'
import Backup from './pages/Backup'
import SystemBackups from './pages/SystemBackups'
import Logs from './pages/Logs'
import Fax from './pages/Fax'

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated)
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />
}

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Protected routes */}
      <Route path="/" element={
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      }>
        <Route index element={<Dashboard />} />
        <Route path="extensions" element={<Extensions />} />
        <Route path="trunks" element={<Trunks />} />
        <Route path="ivr" element={<IVR />} />
        <Route path="time-conditions" element={<TimeConditions />} />
        <Route path="queues" element={<Queues />} />
        <Route path="ring-groups" element={<RingGroups />} />
        <Route path="conferences" element={<Conferences />} />
        <Route path="recordings" element={<Recordings />} />
        <Route path="call-recording" element={<CallRecording />} />
        <Route path="inbound-routes" element={<InboundRoutes />} />
        <Route path="outbound-routes" element={<OutboundRoutes />} />
        <Route path="phonebook" element={<Phonebook />} />
        <Route path="external-destinations" element={<ExternalDestinations />} />
        <Route path="cdr" element={<CDR />} />
        <Route path="tenants" element={<Tenants />} />
        <Route path="users" element={<Users />} />
        <Route path="settings" element={<Settings />} />
        <Route path="global-settings" element={<GlobalSettings />} />
        <Route path="wizard" element={<Wizard />} />
        <Route path="voicemail" element={<Voicemail />} />
        <Route path="parking" element={<Parking />} />
        <Route path="paging" element={<Paging />} />
        <Route path="blacklist" element={<Blacklist />} />
        <Route path="music-on-hold" element={<MusicOnHold />} />
        <Route path="feature-codes" element={<FeatureCodes />} />
        <Route path="provisioning" element={<Provisioning />} />
        <Route path="softphone-provisioning" element={<SoftphoneProvisioning />} />
        <Route path="firmware" element={<Firmware />} />
        <Route path="night-mode" element={<NightMode />} />
        <Route path="announcements" element={<Announcements />} />
        <Route path="fail2ban" element={<Fail2Ban />} />
        <Route path="ami-users" element={<AmiUsers />} />
        <Route path="backup" element={<Backup />} />
        <Route path="system-backups" element={<SystemBackups />} />
        <Route path="logs" element={<Logs />} />
        <Route path="fax" element={<Fax />} />
      </Route>
    </Routes>
  )
}

export default App
